<template>
<component v-if="content" :is="name" :context="context"></component>
</template>
<script>
import Vue from 'vue'
let count = 0

export default {
    props: {
        content: {},
        context: {},
        escaped: {},
    },
    data () {
        return {
            name: this.generateComponent(),
        }
    },
    watch: {
        content () {
            this.name = this.generateComponent()
        },
    },
    methods: {
        generateComponent () {
            let name = `tpl${count++}t${new Date().getTime()}`
            let content = (this.escaped ? unescape(this.content || '') : this.content || '')
                .split('<if>').join('<template v-slot:if>')
                .split('<if/>').join('<template v-slot:if></template>')
                .split('<else/>').join('<template v-slot:else></template>')
                .split('<then/>').join('<template v-slot:then></template>')
                .split('<else>').join('<template v-slot:else>')
                .split('<then>').join('<template v-slot:then>')
                .split('</if>').join('</template>')
                .split('</else>').join('</template>')
                .split('</then>').join('</template>')

            Vue.component(name, {
                props: ['context'],
                template: `<span>${content}</span>`,
                components: require('../utils/components.js').default,
            })
            return name
        },
    },
}
</script>
